/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecommendationResource
 */
export interface RecommendationResource {
    /**
     * 
     * @type {string}
     * @memberof RecommendationResource
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RecommendationResource
     */
    recommenderName?: string;
    /**
     * 
     * @type {string}
     * @memberof RecommendationResource
     */
    text?: string;
}

/**
 * Check if a given object implements the RecommendationResource interface.
 */
export function instanceOfRecommendationResource(value: object): value is RecommendationResource {
    return true;
}

export function RecommendationResourceFromJSON(json: any): RecommendationResource {
    return RecommendationResourceFromJSONTyped(json, false);
}

export function RecommendationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecommendationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'recommenderName': json['recommenderName'] == null ? undefined : json['recommenderName'],
        'text': json['text'] == null ? undefined : json['text'],
    };
}

export function RecommendationResourceToJSON(value?: RecommendationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'recommenderName': value['recommenderName'],
        'text': value['text'],
    };
}

